import { FormStructureTable } from "components/Tables/FormStructureTable/FormStructureTable.tsx";
import { TenantPage } from "components/UI/TenantPage/TenantPage.tsx";
import { FormStructureType, PermissionEnum } from "types/enums.ts";
import { createTenantFileRoute } from "utils/createTenantFileRoute.ts";
import { getToolStructureHeaderItems } from "utils/tenantHeaderItems.ts";

export const Route = createTenantFileRoute("/_authenticated/$tenantSlug/_layout/tool/_layout/structure/_layout/user/")({
    component: UserStructurePage,
    staticData: {
        permissions: [PermissionEnum.ToolStructureUser],
        showInSideMenu: false,
        label: "pages.tool.structure.user.title",
    },
    loader: ({ context: { t } }) => {
        return {
            breadcrumb: t("pages.tool.structure.user.title"),
        };
    },
});

function UserStructurePage() {
    return (
        <TenantPage headerNavigationItems={getToolStructureHeaderItems}>
            <FormStructureTable type={FormStructureType.User} />
        </TenantPage>
    );
}
